/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkturough_Landing_SloganInputs */

const en_walkturough_landing_slogan = /** @type {(inputs: Walkturough_Landing_SloganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plant your Forest,
Grow your Focus.`)
};

const ar_walkturough_landing_slogan = /** @type {(inputs: Walkturough_Landing_SloganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ازرع غابتك،
ونمِّى تركيزك.`)
};

const de_walkturough_landing_slogan = /** @type {(inputs: Walkturough_Landing_SloganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pflanze deinen Wald, 
lass deinen Fokus wachsen.`)
};

const es_walkturough_landing_slogan = /** @type {(inputs: Walkturough_Landing_SloganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planta tu bosque,
Haz crecer tu concentración.`)
};

const fr_walkturough_landing_slogan = /** @type {(inputs: Walkturough_Landing_SloganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantez votre forêt, 
Développez votre concentration.`)
};

const it_walkturough_landing_slogan = /** @type {(inputs: Walkturough_Landing_SloganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pianta la tua foresta, 
Coltiva la tua concentrazione.`)
};

const ja_walkturough_landing_slogan = /** @type {(inputs: Walkturough_Landing_SloganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`森を育てて
集中力を伸ばそう`)
};

const ko_walkturough_landing_slogan = /** @type {(inputs: Walkturough_Landing_SloganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`숲을 가꾸고,
집중력을 높이세요.`)
};

const pt_br_walkturough_landing_slogan = /** @type {(inputs: Walkturough_Landing_SloganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plante sua floresta,
Aumente seu foco.`)
};

const ru_walkturough_landing_slogan = /** @type {(inputs: Walkturough_Landing_SloganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выращивайте лес,
улучшайте фокусировку.`)
};

const th_walkturough_landing_slogan = /** @type {(inputs: Walkturough_Landing_SloganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลูกป่าของคุณ
เสริมสร้างการโฟกัส`)
};

const tr_walkturough_landing_slogan = /** @type {(inputs: Walkturough_Landing_SloganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ormanını Ekerken
Odağını Büyüt.`)
};

const zh_cn_walkturough_landing_slogan = /** @type {(inputs: Walkturough_Landing_SloganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专注，看得见  
开启你的专注森林之旅！`)
};

const zh_tw_walkturough_landing_slogan = /** @type {(inputs: Walkturough_Landing_SloganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專注，看得見  
開啟你的專注森林之旅！`)
};

/**
* | output |
* | --- |
* | "Plant your Forest, Grow your Focus." |
*
* @param {Walkturough_Landing_SloganInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const walkturough_landing_slogan = /** @type {((inputs?: Walkturough_Landing_SloganInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkturough_Landing_SloganInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_walkturough_landing_slogan(inputs)
	if (locale === "ar") return ar_walkturough_landing_slogan(inputs)
	if (locale === "de") return de_walkturough_landing_slogan(inputs)
	if (locale === "es") return es_walkturough_landing_slogan(inputs)
	if (locale === "fr") return fr_walkturough_landing_slogan(inputs)
	if (locale === "it") return it_walkturough_landing_slogan(inputs)
	if (locale === "ja") return ja_walkturough_landing_slogan(inputs)
	if (locale === "ko") return ko_walkturough_landing_slogan(inputs)
	if (locale === "pt_br") return pt_br_walkturough_landing_slogan(inputs)
	if (locale === "ru") return ru_walkturough_landing_slogan(inputs)
	if (locale === "th") return th_walkturough_landing_slogan(inputs)
	if (locale === "tr") return tr_walkturough_landing_slogan(inputs)
	if (locale === "zh_cn") return zh_cn_walkturough_landing_slogan(inputs)
	return zh_tw_walkturough_landing_slogan(inputs)
});